import template from './wageAdvanceResume.html';
import controller from './wageAdvanceResume.controller';
import './wageAdvanceResume.scss';

let wageAdvanceResumeComponent = {
  restrict: 'E',
  bindings: {
    wageAdvance: '<',
    finishWageAdvance: '&',
    cancelWageAdvance: '&',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default wageAdvanceResumeComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/wageAdvance/wageAdvanceResume/wageAdvanceResume.component.js